var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54688 0.555556C5.54688 0.248731 5.29814 0 4.99132 0C4.68449 0 4.43576 0.248731 4.43576 0.555556V4.44553H0.555555C0.248731 4.44553 0 4.69426 0 5.00108C0 5.30791 0.24873 5.55664 0.555555 5.55664H4.43576V9.44444C4.43576 9.75127 4.68449 10 4.99132 10C5.29814 10 5.54688 9.75127 5.54688 9.44444V5.55664H9.44444C9.75127 5.55664 10 5.30791 10 5.00108C10 4.69426 9.75127 4.44553 9.44444 4.44553H5.54688V0.555556Z",
    fill: "#7663EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.3946ce7b418bec7c458e6fddb7109727.svg";
export { ForwardRef as ReactComponent };